/* =========================================================
   ES Wishlist Badge State (dot only)
   - Desktop + mobile header show a small dot (not a number).
   - Persist a lightweight "has wishlist items" flag in localStorage
     so the dot does not flash off/on during navigation.
   ========================================================= */
(function () {
  'use strict';

  var KEY_HAS = 'es_wl_confirmed_has_items';
  var KEY_TS  = 'es_wl_confirmed_ts';

  function safeGet(key) {
    try { return (window.localStorage && localStorage.getItem(key)) || ''; }
    catch (e) { return ''; }
  }
  function safeSet(key, val) {
    try { if (window.localStorage) localStorage.setItem(key, val); }
    catch (e) {}
  }

  function setRootFlag(has) {
    var root = document.documentElement;
    if (!root || !root.classList) return;
    root.classList.toggle('es-wishlist-has-items', !!has);
  }

  function setMobileDot(has) {
    var els = document.querySelectorAll('.swym-wishlist-header-counter.swym-mobile');
    if (!els || !els.length) return;
    for (var i = 0; i < els.length; i++) {
      try {
        els[i].classList.toggle('show-badge', !!has);
        // Keep markup clean: dot is purely visual (ignore any injected numbers)
        // but do not forcibly clear text to avoid fighting Swym.
      } catch (e) {}
    }
  }

  function textCount(txt) {
    txt = (txt || '').trim();
    if (!txt) return 0;
    if (txt === '9+') return 9;
    var n = parseInt(txt, 10);
    return isNaN(n) ? 0 : n;
  }

  function getBadges() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.swym-wishlist-header-counter')
    );
  }

  function isReady(el) {
    try { return !!(el && el.getAttribute && el.getAttribute('data-es-wl-ready') === '1'); }
    catch (e) { return false; }
  }

  function shouldShow(el) {
    if (!el) return false;
    try {
      if (el.classList && el.classList.contains('show-badge')) return true;
    } catch (e) {}
    return textCount(el.textContent) > 0;
  }

  function computeState() {
    var badges = getBadges();
    if (!badges.length) return { has: false, ready: false };

    // "Ready" means Swym has loaded/hydrated. We expose a stable hook in swym-custom.liquid:
    //   window.__esSwat = swat;
    var ready = !!(window.__esSwat || window._swat || window.SwymWishlist || window.Swym);
    var has = false;

    for (var i = 0; i < badges.length; i++) {
      if (shouldShow(badges[i])) has = true;
    }
    return { has: has, ready: ready };
  }

  function syncPersistedFlag() {
    var state = computeState();

    // Before Swym hydrates, keep the current prestate (do NOT force-hide).
    if (!state.ready) return;

    setRootFlag(state.has);
    setMobileDot(state.has);

    safeSet(KEY_HAS, state.has ? '1' : '0');
    safeSet(KEY_TS, String(Date.now()));
  }

  function scheduleSync(ms) { setTimeout(syncPersistedFlag, ms); }

  // Apply cached state ASAP for mobile (extra safety beyond <head> prestate)
  (function applyCache(){
    try {
      var has = safeGet(KEY_HAS) === '1';
      setMobileDot(has);
    } catch (e) {}
  })();

  function attachObservers() {
    var badges = getBadges();
    if (!badges.length || !window.MutationObserver) return;

    try {
      var mo = new MutationObserver(function () {
        scheduleSync(30);
      });
      badges.forEach(function (el) {
        try {
          mo.observe(el, {
            childList: true,
            characterData: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'data-es-wl-ready']
          });
        } catch (e) {}
      });
    } catch (e) {}
  }

  // Initialize from cache (in case theme.liquid prestate was blocked)
  (function initFromCache(){
    try {
      var has = safeGet(KEY_HAS);
      var tsRaw = safeGet(KEY_TS);
      var ts = parseInt(tsRaw, 10) || 0;
      var ttl = 7*24*60*60*1000; // 7 days
      if (has === '1' && (!ts || (Date.now() - ts) < ttl)) {
        setRootFlag(true);
        setMobileDot(true);
      } else if (has === '0') {
        setRootFlag(false);
        setMobileDot(false);
      }
    } catch (e) {}
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(150);
      scheduleSync(450);
      scheduleSync(1200);
      scheduleSync(2600);
      attachObservers();
    });
  } else {
    scheduleSync(150);
    scheduleSync(450);
    scheduleSync(1200);
    scheduleSync(2600);
    attachObservers();
  }

  // Swym emits events on add/remove; optimistic dot update + re-sync shortly after.
  document.addEventListener('swym:addedtowishlist', function () {
    try {
      safeSet(KEY_HAS, '1');
      safeSet(KEY_TS, String(Date.now()));
      setRootFlag(true);
      setMobileDot(true);
    } catch (e) {}
    scheduleSync(120);
    scheduleSync(420);
  });

  document.addEventListener('swym:removedfromwishlist', function () {
    // Don't force-hide immediately; Swym will re-hydrate the true count.
    scheduleSync(120);
    scheduleSync(420);
  });

  // BFCache (back/forward): ensure state is consistent.
  window.addEventListener('pageshow', function () {
    scheduleSync(80);
  });
})();
